import React, { Component } from 'react';
import { API_URL } from '../../constants/api';
import { apiBatchRequest, apiPost, downloadReport } from '../../utils/api_service';
import { ShowToast, toastType } from '../../utils/toast-service';
import commonLabels from '../../constants/messageConstants';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import { GridTable } from '../common/Table/Table';
import { applyFilterOnData, cloneDeep, GenerateAbsoluteURL, getCurrentPayCycle, numberWithCommas, removeDuplicates, UpdateColumnWithConfiguration, useQuery } from '../../utils/helper';
import { closePayCycleColumn } from '../../constants/MockData';
import { AppBar, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, FormControlLabel, IconButton, Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Tooltip, Typography } from '@material-ui/core';
import { controlType } from '../../constants/common';
import _ from 'lodash';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { DateFormat, Operators } from '../../constants/appConstants';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import './closePaycyle.less';
import { getFormattedValuesForReport } from '../../utils/formatData';
import moment from 'moment';

// Component used to close Pay Periods
export class ClosePayCycle extends Component {
  // Constructor to set initial state
  constructor() {
    super();
    this.state = {
      payPeriodMasterData: [],
      payPeriodData: [],
      selectedData: [],
      responsePayPeriodData: [],
      isPopupOpen: false,
      confirmationMessage: '',
      updateData: undefined,
      configuration: [],
      isBack: false,
      isAgree: false,
      isSave: false,
      reimbursementSummaryDetails: [],
      numberOfUnmappedPayCode: [],
      unmappedARAdminProperty: []
    };
  }

  // Get API data before components are mounted
  componentDidMount() {
    this.LoadData();
  }

  // Handle filter value change event
  onFilterChange = (selectedData) => {
    const { responsePayPeriodData } = this.state;
    this.setState({ payPeriodData: applyFilterOnData(_.cloneDeep([...responsePayPeriodData]), selectedData), selectedData: selectedData });
  };

  // Get master data from API
  LoadData() {
    const query = useQuery();
    const isBack = query.get('isBack');
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Allocation.GetPayPeriod,
        key: 'payPeriodData'
      }
    ])
      .then(
        ({
          payPeriodData
        }) => {
          this._asyncRequest = null;
          if (payPeriodData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          } else {
            this.setState({
              payPeriodData: applyFilterOnData(cloneDeep(payPeriodData.data || []), this.state.selectedData),
              responsePayPeriodData: cloneDeep(payPeriodData.data || []),
              payPeriodMasterData: cloneDeep(payPeriodData.data || []),
              configuration: payPeriodData.config,
              isBack: (isBack === 'true' || isBack === true)
            });
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Handle popup action events
  onPopupClickHandle = (value) => {
    if (value) {
      if (this.state.isAgree) { this.closeAllocation(); } else { this.setState({ isSave: true }); }
    } else {
      this.setState({ isPopupOpen: false, confirmationMessage: '', isSave: false, isAgree: false });
    }
  }

  // Close selected pay period
  closeAllocation = () => {
    const { updateData, reimbursementSummaryDetails, numberOfUnmappedPayCode } = this.state;
    let summary1 = 'Number Of Employees Applicable For Adjustments: ';
    let summary2 = 'Number Of Employees Adjusted: ';
    let summary3 = 'Unmapped Pay Codes: ';

    reimbursementSummaryDetails.map(x => {
      summary1 += x.payCode + ' ' + x.totalNumberOfEmployee + ' ';
      summary2 += x.payCode + ' ' + x.totalNumberOfAdjustedEmployee + ' ';
      return x;
    });
    numberOfUnmappedPayCode.map(x => {
      summary3 += x.payCode + ' ';
      return x;
    });

    const postBodyData = {
      payPeriodId: updateData.payPeriodId,
      isMarketYearEndBonus: updateData.isMarketYearEndBonus,
      isClosed: true,
      summary: summary1 + ' and ' + summary2 + ' summary3 ' + summary3
    };
    apiPost({
      url: API_URL.Allocation.ClosePayPeriod,
      params: {},
      postBody: postBodyData
    }).then(({ data: response }) => {
      if (response.success) {
        ShowToast('Pay Period Closed Successfully.', toastType.SUCCESS, 5000, 500);
        this.setState({ isPopupOpen: false, confirmationMessage: '', isPreviousToCurrentOrFuture: false, updateData: undefined, isSave: false, isAgree: false }, () => { this.LoadData(); });
      } else {
        this.setState({ isPopupOpen: false, confirmationMessage: '', isPreviousToCurrentOrFuture: false, updateData: undefined, isSave: false, isAgree: false });
      }
    });
  }

  // Get reimbursement adjustment summary data of selected pay period while closing of pay period
  EndPayCycle = (row) => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetReimbursementAdjustmentSummary + '?periodStartDate=' + row.periodStartDate + '&periodEndDate=' + row.periodEndDate,
        key: 'reimbursementAdjustmentSummary'
      },
      {
        url: API_URL.Property.GetUnmappedARAdminProperty + '?payPeriodStartDate=' + row.periodStartDate + '&payPeriodEndDate=' + row.periodEndDate,
        key: 'unmappedARAdminProperty'
      }
    ])
      .then(
        ({
          reimbursementAdjustmentSummary,
          unmappedARAdminProperty
        }) => {
          this._asyncRequest = null;
          if (reimbursementAdjustmentSummary.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          } else {
            if ((row.isMarketYearEndBonus === false && reimbursementAdjustmentSummary.config !== null && reimbursementAdjustmentSummary.data !== null) ||
              (row.isMarketYearEndBonus === true && reimbursementAdjustmentSummary.data !== null)) {
              this.setState({
                reimbursementSummaryDetails: reimbursementAdjustmentSummary.data || [],
                numberOfUnmappedPayCode: reimbursementAdjustmentSummary.config || [],
                isPopupOpen: true,
                confirmationMessage: row.isMarketYearEndBonus === true
                  ? <span>Are You Sure You Want To Close Year End Bonus Reimbursement Pay Period: <b>{row.payPeriod}</b>?</span>
                  : <span>Are You Sure You Want To Close Pay Period: <b>{row.payPeriod}</b>?</span>,
                updateData: row,
                unmappedARAdminProperty: unmappedARAdminProperty.data
              });
            } else {
              ShowToast(
                <span>There is no Pay Statement received from UltiPro for the pay period {row.payPeriod}.</span>,
                toastType.ERROR,
                5000,
                500
              );
            }
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Render Edit/Update/Cancel action buttons for every record
  renderActionColumn = (row) => {
    return (
      <>
        { row.isClosed === false
          ? <Tooltip title="Close pay period">
            <IconButton
              aria-label={'refreshData'}
              size="small"
              onClick={() => {
                this.EndPayCycle(row);
              }}
            >
              <HighlightOffIcon fontSize="small" size="small" />
            </IconButton>
          </Tooltip>
          : ''
        }
      </>
    );
  };

  // Navigate to Billing screen
  goToBillingScreen = () => {
    this.props.history.push('/billingAccountingAdjustments');
  }

  // Handle event
  isAcceptCondition = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
  }

  // Download unmapped paycodes report for selected pay period
  downloadReport = () => {
    const dataValue = [
      { key: 'PeriodStartDate', value: moment(this.state.updateData.periodStartDate).format(DateFormat) },
      { key: 'PeriodEndDate', value: moment(this.state.updateData.periodEndDate).format(DateFormat) }
    ];
    const url = GenerateAbsoluteURL(dataValue, [], 'Pay%20Code%20Mapping%20Report', 'Excel', false, true);

    downloadReport(
      url,
      'Reimbursement Adjustment Summary',
      'application/vnd.ms-excel', 'Excel'
    );
  }

  // Render components based on conditions
  render() {
    const { unmappedARAdminProperty, payPeriodData, payPeriodMasterData, selectedData, isPopupOpen, confirmationMessage, configuration, reimbursementSummaryDetails, isAgree, isSave, numberOfUnmappedPayCode, updateData } = this.state;
    return (
      <>
        {isPopupOpen && (
          <Dialog open={isPopupOpen} maxWidth="lg" >
            <AppBar
              style={{ position: 'relative', backgroundColor: '#064473' }}
            >
              <Toolbar>
                <Typography
                  variant="h6"
                  className="app-header-white"
                  style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                >
                  {'Reimbursement Adjustment Summary Details'}
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="close"
                  style={{ paddingLeft: '40px' }}
                >
                  <IoMdCloseCircleOutline onClick={() => { this.onPopupClickHandle(false); }}
                  />
                </IconButton>
              </Toolbar>
            </AppBar>
            <DialogContent dividers>
              <DialogContentText style={{ color: '#002f6c' }}>
                {confirmationMessage}
              </DialogContentText>
              <DialogContentText style={{ color: '#002f6c' }}>
                Please Verify Reimbursement Summary Details Below:
              </DialogContentText>
              <DialogContentText style={{ color: '#002f6c' }}>
                <label> <b> Adjusted Pay Codes </b> </label>
              </DialogContentText>
              <DialogContentText>
                <TableContainer className='close-payCycle'>
                  <Table>
                    <TableHead >
                      <TableRow>
                        <TableCell className='header'>Pay Code</TableCell>
                        <TableCell className='header' width={'40%'}><span className="close-number-text">Number Of Employees Applicable For Adjustments </span></TableCell>
                        <TableCell className='header'><span className="close-number-text">Number Of Employees Adjusted </span></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {reimbursementSummaryDetails.map((summary, index) => (
                        <TableRow key={index} className={index % 2 === 0 ? 'close close-even header' : 'close close-odd header'}>
                          <TableCell >
                            {summary.payCode}
                          </TableCell>
                          <TableCell width={'40%'}>
                            <span className="close-number-text">{summary.totalNumberOfEmployee}</span>
                          </TableCell>
                          <TableCell >
                            <span className="close-number-text">{summary.totalNumberOfAdjustedEmployee}</span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>

                  </Table>
                </TableContainer>
              </DialogContentText>
              {updateData.isMarketYearEndBonus === false &&
                (<>
                  <DialogContentText style={{ color: '#002f6c' }}>
                    <label> <b> Unmapped Pay Codes </b> </label> &nbsp; &nbsp;
                  </DialogContentText>
                  <DialogContentText style={{ color: '#002f6c' }}>
                    <TableContainer className='close-payCycle' style={{ height: '200px' }}>
                      <Table stickyHeader>
                        <TableHead >
                          <TableRow>
                            <TableCell className='header'>Pay Code</TableCell>
                            <TableCell className='header'>Pay Code Type</TableCell>
                            <TableCell className='header' > <span className="close-number-text">Number Of Employees </span></TableCell>
                            <TableCell className='header' > <span className="close-number-text">Pay Code Amount</span></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {numberOfUnmappedPayCode.map((summary, index) => (
                            <TableRow key={index} className={index % 2 === 0 ? 'close close-even header' : 'close close-odd header'}>
                              <TableCell >
                                {summary.payCode}
                              </TableCell>
                              <TableCell className='header'>
                                {summary.payCodeType === null ? '-' : summary.payCodeType}
                              </TableCell>
                              <TableCell >
                                {summary.noOfEmployees === null ? <span className="close-number-text">-</span> : <span className="close-number-text">{numberWithCommas(summary.noOfEmployees)} </span>}
                              </TableCell>
                              <TableCell >
                                {summary.payCodeAmount === null
                                  ? <span className="close-number-text">-</span>
                                  : getFormattedValuesForReport(summary.payCodeAmount, 'MoneyDecimal')}
                              </TableCell>
                            </TableRow>
                          ))}
                          <TableRow>
                            <TableCell >
                              <b>{'Total'}</b>
                            </TableCell>
                            <TableCell >
                            </TableCell>
                            <TableCell >
                              <b><span className="close-number-text">{numberWithCommas(numberOfUnmappedPayCode.reduce((total, obj) => (parseFloat(obj.noOfEmployees) + parseFloat(total)), 0))} </span></b>
                            </TableCell>
                            <TableCell >
                              <b>{getFormattedValuesForReport(numberOfUnmappedPayCode.reduce((total, obj) => (parseFloat(obj.payCodeAmount) + parseFloat(total)), 0), 'MoneyDecimal')}</b>
                            </TableCell>
                          </TableRow>
                        </TableBody>

                      </Table>
                    </TableContainer>
                  </DialogContentText>
                  <DialogContentText style={{ color: '#002f6c' }}>
                    <label> <b> Unmapped AR Admin Property </b> </label> &nbsp; &nbsp;
                  </DialogContentText>
                  <DialogContentText style={{ color: '#002f6c' }}>
                    <TableContainer className='close-payCycle' style={{ height: '200px' }}>
                      <Table stickyHeader>
                        <TableHead >
                          <TableRow>
                            <TableCell className='header'>Property</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {unmappedARAdminProperty.map((unmappedProperty, index) => (
                            <TableRow key={index} className={index % 2 === 0 ? 'close close-even header' : 'close close-odd header'}>
                              <TableCell >
                                {unmappedProperty.propertyName}
                              </TableCell>
                            </TableRow>
                          ))}
                          {unmappedARAdminProperty?.length <= 0 &&
                            <TableRow>
                              <TableCell >
                                <label className="item-small">No Data Available.</label>
                              </TableCell>
                            </TableRow>
                          }
                        </TableBody>

                      </Table>
                    </TableContainer>
                  </DialogContentText>
                  <DialogContentText>
                    <Link style={{ cursor: 'pointer' }} onClick={() => this.downloadReport()} to="">
                      {'Download Reimbursement Adjustment Summary'}
                    </Link>
                  </DialogContentText>

                  <DialogContentText style={{ color: 'red' }}>
                    <label> <b>Note: </b> Closing The Current Pay Period Will Close Any Previous Pay Periods. </label> &nbsp; &nbsp;
                  </DialogContentText>
                </>)
              }
            </DialogContent>

            <div className="row col-xs-12 col-lg-12 field-control" style={{ marginLeft: '10px', marginBottom: '10px' }}>
              <div className="col-xs-6">
                <DialogContentText className="label-content" style={{ marginLeft: '9px' }}>
                  <FormControlLabel
                    key={'checkbox_'}
                    value={isAgree}
                    control={
                      <Checkbox
                        color="primary"
                        checked={isAgree}
                        onChange={(event) => { this.isAcceptCondition(event); }}
                        name={'isAgree'}
                      />
                    }
                    style={{ color: '#002f6c' }} label={'I Agree'}
                    labelPlacement="end"
                  />
                </DialogContentText>
                {isAgree !== true && isSave === true &&
                  <DialogContentText style={{ marginLeft: '9px', color: 'red' }}>
                    Please Select I Agree.
                </DialogContentText>
                }
              </div>
              <div className="col-xs-6 end-xs">
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => {
                    this.onPopupClickHandle(true);
                  }}
                  style={{ marginTop: '6px' }}
                >
                  {'Submit'}
                </Button>
              </div>
            </div>
          </Dialog>
        )
        }
        {
          <>
            <PageHeader title="Close Pay Period"></PageHeader>
            {this.state.isBack === true && <div className="row start-xs end-xs">
              <div className="col-xs-auto backpage">
                <Tooltip title="Back To Billing/Accounting Adjustments">
                  <IconButton
                    aria-label={'refreshData'}
                    size="small"
                    onClick={() => { }}
                  >
                    <ArrowBackIcon size="small" className="back-button" onClick={(e) => this.goToBillingScreen()} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>}
            <PageFilter
              autoFilter={false}
              filterAlwaysVisible={true}
              onFilterChanged={this.onFilterChange}
              filterConfig={[
                {
                  multiple: true,
                  type: controlType.DropDown,
                  source: removeDuplicates(payPeriodMasterData, 'payPeriod'),
                  key: 'payPeriod',
                  placeholder: 'Pay Period',
                  title: 'Pay Period',
                  ignoreSort: true
                },
                {
                  multiple: false,
                  type: controlType.DatePicker,
                  key: 'periodStartDate',
                  title: 'Period Start Date',
                  operator: Operators.GreaterThanEqualsTo
                },
                {
                  multiple: false,
                  type: controlType.DatePicker,
                  key: 'periodEndDate',
                  title: 'Period End Date',
                  operator: Operators.LessThanEqualsTo,
                  And: {
                    key: 'periodStartDate',
                    operator: Operators.LessThanEqualsTo
                  }
                }
              ]}
              gridColumn={3}
              defaultSelectedData={[]}
              selectedData={selectedData}
            ></PageFilter>

            <div className="row table-list-container">
              <GridTable
                columns={UpdateColumnWithConfiguration(
                  closePayCycleColumn,
                  this.state.configuration
                )}
                data={payPeriodData || []}
                renderActionColumn={this.renderActionColumn}
                rowBadge={{
                  key: 'isMarketYearEndBonus',
                  equalsTo: true,
                  class: 'message rotate-badge',
                  title: 'YEB',
                  tooltip: 'Market Year End Bonus Pay Period',
                  separateBySpace: true
                }}
              ></GridTable>
            </div>
          </>
        }
      </>
    );
  }
}

export default ClosePayCycle;
